import type { ElementType, HTMLAttributes } from "react";

export type TextVariant = "caption" | "label" | "mono" | "muted" | "numeric";

export const TEXT_CLASSES: Record<TextVariant, string> = {
  caption:
    "font-mono text-[10px] font-bold uppercase tracking-[0.16em] text-slate-500 dark:text-slate-400",
  label:
    "font-mono text-[10px] font-bold uppercase tracking-widest text-slate-500 dark:text-slate-400",
  mono: "font-mono text-xs text-slate-600 dark:text-slate-300",
  muted: "text-xs text-slate-500 dark:text-slate-400",
  numeric: "text-xs tabular-nums text-slate-600 dark:text-slate-300",
};

interface TextProps extends HTMLAttributes<HTMLElement> {
  variant?: TextVariant;
  as?: ElementType;
}

export function Text({
  variant = "muted",
  as: Tag = "span",
  className = "",
  children,
  ...rest
}: TextProps) {
  return (
    <Tag className={`${TEXT_CLASSES[variant]} ${className}`.trim()} {...rest}>
      {children}
    </Tag>
  );
}
